import { render } from "./CGroup.vue?vue&type=template&id=68bc9890&scoped=true"
import script from "./CGroup.vue?vue&type=script&lang=js"
export * from "./CGroup.vue?vue&type=script&lang=js"

import "./CGroup.vue?vue&type=style&index=0&id=68bc9890&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bc9890"]])

export default __exports__